// src/pages/PortfolioPage.tsx
import React from 'react';
import Header from '../components/Header';
import Home from './Home';
import About from './About';
import Portfolio from './Portfolio';
import Skills from './Skills';
import Contact from './Contact';
import Footer from '../components/Footer';

const PortfolioPage: React.FC = () => (
  <>
    <Header />
    <main>
      <Home />
      <About />
      <Portfolio />
      <Skills />
      <Contact />
    </main>
    <Footer />
  </>
);

export default PortfolioPage;
